// get all users
export const getAllJobs = (filters) => ({
  url: "/admin/jobs",
  method: "GET",
  params: filters,
});
export const getSingleJob = (id) => ({
  url: `/admin/job/${id}`,
  method: "GET",
});
export const deleteJob = (id) => ({
  url: `/admin/job/${id}`,
  method: "DELETE",
});
export const assignJob = (body) => ({
  url: "/admin/assign-job",
  method: "POST",
  body,
});
export const updateJob = ({ id, body }) => ({
  url: `/admin/update-job/${id}`,
  method: "PUT",
  body,
});
